export default {
    // 两数之间的随机数
    randomNum(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // 从数组中获取指定数量的元素，且不重复
    getRandomArrayValue(arr, num) {
        if (num > arr.length) return arr;
        var sData = arr.slice(0),
            i = arr.length,
            min = i - num,
            item,
            index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            item = sData[index];
            sData[index] = sData[i];
            sData[i] = item;
        }
        return sData.slice(min);
    },
    // ls默认前缀： kofh5local_
    getLs(name) {
        let _data = JSON.parse(localStorage.getItem('kofh5local_' + name));
        return _data;
    },
    setLs(name, data) {
        let _data = JSON.stringify(data);
        localStorage.setItem('kofh5local_' + name, _data);
    },
    removeLs(name) {
        localStorage.removeItem('kofh5local_' + name);
    }
};
